import React from 'react';
import { Table, Empty, Button, Input, Form, Select } from 'antd';
const { Option } = Select;


export default function DetalleVehiculoModal(props) {

    const onKeyPressTextNumber = (e) => {
        const regUpper = /[A-Z]+/;
        const regLower = /[a-z]+/;
        const regNumber = /[0-9]+/;
        const pressedKey = String.fromCharCode(!e.charCode ? e.which : e.charCode);
        if (regUpper.test(pressedKey) || regLower.test(pressedKey) || regNumber.test(pressedKey)) {
            return true;
        } else {
            e.preventDefault();
            return false;
        }
    }
    return (
        <div>
            <Table
                style={{ overflowX: 'auto' }}
                className={'table-vehiculo'}
                size="small"
                pagination={false}
                dataSource={props.dataSource}
                rowKey={record => record.identifier}
                locale={{
                    emptyText: <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description='Pulse el bot+on "+ Agregar".'
                    />
                }}
                columns={[
                    {
                        key: 'remove-button',
                        align: 'center',
                        width: '50px',
                        render: (value, row) => (
                            <span>
                                <div className="custom-options">
                                    <Button
                                        type="danger"
                                        icon="delete"
                                        size={"small"}
                                        onClick={() => props.onRemove(row)}
                                    />
                                </div>
                            </span>
                        )
                    },
                    {
                        title: 'Descripcion',
                        dataIndex: 'idVehiculo',
                        key: 'idVehiculo',
                        width: 50,
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrnombreVehiculo[${row.identifier}]`, {
                                        initialValue: value ? { key: value } : undefined,
                                        rules: [{
                                            required: true,
                                            message: 'Requerido'
                                        }]
                                    })(
                                        <Select showSearch labelInValue
                                            placeholder={"Seleccione Vehiculo"}
                                            optionFilterProp="children"
                                            onChange={(value, option) => {
                                                props.onChangeVehiculo(value.key, 'arrnombreVehiculo', row.identifier, option);
                                            }}
                                        >
                                            {props.vehiculos.map(item => (
                                                props.idVehiculo == item.id ? null :
                                                    < Option key={item.id} value={item.id} tuc={item.tuc} >
                                                        {item.placa}({item.marca} - {item.modelo} - {item.color})
                                                    </Option>
                                            ))
                                            }
                                        </Select>
                                    )
                                    }
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: 'Tuc',
                        dataIndex: 'tuc',
                        key: 'tuc',
                        width: 150,
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrTuc[${row.identifier}]`, {
                                        initialValue: value,
                                        validateTrigger: ['onBlur'],
                                        rules: [{
                                            required: false,
                                            message: 'Requerido',
                                            whitespace: true
                                        }]
                                    })(
                                        <Input
                                            placeholder="Tuc"
                                            autoComplete="off"
                                            maxLength={15}
                                            onKeyPress={onKeyPressTextNumber}
                                            onBlur={(e) => props.onChangeVehiculo(e.target.value, 'arrTuc', row.identifier, row)}

                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },

                ]}
            />
        </div >
    );
}